<template>
  <b-card>
    <div style="position: relative">
      <loading-overlay :loading="loading" />
      <div class="d-flex justify-content-between">
        <h3>الأخبار</h3>
        <b-button
          variant="success"
          @click="isModalVisible = true"
          v-can="{ slug: $route.meta.slug, action: 'C' }"
        >
          <feather-icon icon="PlusIcon" />
          إضافة</b-button
        >
      </div>
      <hr />
      <news-card
        v-for="(item, i) in news"
        :key="i"
        :info="item"
        v-can="{ slug: $route.meta.slug, action: 'S' }"
      ></news-card>
      <alert
        v-if="news.length == 0 && !loading"
        class="w-100"
        :massage="$t('alert')"
      >
      </alert>
      <Pagination
        v-can="{ slug: $route.meta.slug, action: 'S' }"
        v-model="currentPage"
        :total-rows="pagination.total_row"
        :per-page="pagination.per_page"
        align="end"
        class="mt-2"
      >
      </Pagination>
      <form-modal
        v-model="isModalVisible"
        title="معلومات الخبر"
        :formSchema="formSchema"
        ref="newsModal"
        @confirm="handleNewsSubmit"
        :loading="working"
      >
        <template #slides="{ form }">
          <news-images-input v-model="form.slides"></news-images-input>
        </template>
        <template  #video="{ form }">
          
          <form-file-input
              placeholder="اختر فيديو ..."
              id="document"
              accept="video/mp4,video/x-m4v,video/*"
              v-model="form.video"
              label="الفيديو" 
              sizeLimit = "20"
            />
        </template>
      </form-modal>

      <!-- <modal-news
        v-model="activSide"
        :newsFormSchema="newsFormSchema"
        type="ADD"
      ></modal-news> -->
    </div>
  </b-card>
</template>
<script>
// import ModalNews from "../../components/ModalNews.vue";
// import FormInput from "@/components/form-input/index.vue";
// import FormMask from "@/components/form-mask/index.vue";
// import FormDatepicker from "@/components/form-datepicker/index.vue";
// import FormSelect from "@/components/form-select";
import { BCard, BButton } from "bootstrap-vue";
import NewsCard from "../../components/NewsCard";
import { mapGetters, mapActions } from "vuex";
import Pagination from "@/components/pagination/index.vue";
// import FormTextarea from "@/components/form-textarea/index.vue";
import Alert from "@/components/Alert.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import FormModal from "@/components/FormModal";
import NewsImagesInput from "../../components/NewsImagesInput";
import FormFileInput from "@/components/FormFileInput.vue";
export default {
  components: {
    BCard,
    Alert,
    BButton,
    NewsCard,
    Pagination,
    // FormInput,
    // FormMask,
    // FormSelect,
    // FormTextarea,
    // ModalNews,
    // FormDatepicker,
    LoadingOverlay,
    FormModal,
    NewsImagesInput,
    FormFileInput
  },
  data: () => {
    return {
      currentPage: 1,
      isModalVisible: false,
      activSide: false,
      formSchema: {
        image: {
          component: "FormImageInput",
          key: "image",
          attrs: {
            label: "صورة الخبر",
            id: "form-image",
            name: "image",
            withCropper: true,
            cropAspectRatio: 16 / 9,
            rules: "required",
          },
        },
        title_ar: {
          component: "FormInput",
          key: "title_ar",
          attrs: {
            label: "العنوان",
            rules: "required",
          },
        },

        accomplished_at_date: {
          component: "FormMask",
          key: "accomplished_at_date",
          attrs: {
            label: "التاريخ",
            options: "date",
            rules: "required",
            placeholder: "YYYY-MM-DD",
          },
        },

        governorate_id: {
          component: "FormSelect",
          key: "governorate_id",
          attrs: {
            id: "gov_news_add",
            label: "المحافظة",
            ep: "v2/selects/governorates",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
            rules: "required",
          },
        },
        description_ar: {
          component: "FormTextarea",
          key: "description_ar",
          attrs: {
            label: "الوصف",
            rules: "required",
          },
        },
        video: {
          key: "video",
          // component: "FormFileInput",
          // attrs: {
          //   label: "الفيديو",
          //   placeholder: "اختر فيديو ...",
          //   accept: "video/mp4,video/x-m4v,video/*",
          // },
        },
        slides: {
          key: "slides",
        },
      },
    };
  },
  watch: {
    currentPage(val) {
      this.getNews({
        page: val,
      });
    },
  },
  computed: {
    ...mapGetters("manageInterfaceNgo/NewsManagement", [
      "news",
      "loading",
      "pagination",
      "working",
    ]),
  },

  methods: {
    ...mapActions("manageInterfaceNgo/NewsManagement", [
      "getNews",
      "createNews",
    ]),
    handleNewsSubmit(form) {
      this.createNews(form).then(() => {
        this.isModalVisible = false;
        this.getNews({
          page: this.currentPage,
        });
      });
    },
  },

  created() {
    this.getNews({
      page: this.currentPage,
    });
  },
};
</script>
